import { render, staticRenderFns } from "./TextManager.vue?vue&type=template&id=2f725fde&scoped=true"
import script from "./TextManager.vue?vue&type=script&lang=js"
export * from "./TextManager.vue?vue&type=script&lang=js"
import style0 from "./TextManager.vue?vue&type=style&index=0&id=2f725fde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f725fde",
  null
  
)

export default component.exports